var styles = {
  bold: {
    fontWeight: "bold"
  },
  messageContainer: {
    marginBottom: "20px",
    marginTop: "-10px"
  },
  message: {
    display: "flex",
    alignItems: "center",
    border: "1px solid #e9e9e9",
    width: "100%",
    borderRadius: "3px",
    padding: "10px"
  },
  icon: {
    width: "24px",
    height: "24px"
  },
  iconContainer: {
    width: "35px"
  },
  tryAgainLink: {
    color: "inherit",
    textDecoration: "underline"
  }
};
export default styles;